/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "d9802acf590e94a3e2ce6445938835650a7e3ddd";
